import _defineProperty from "/data/buildAgent/sid-teamcity-agent-01/work/7ee7b29b3220b2e5/portals/UPGRADE/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { JSON_CONTENT_TYPE, CONTENT_TYPE } from '../common';
export var jsonOptions = {
  headers: _defineProperty({}, CONTENT_TYPE, "".concat(JSON_CONTENT_TYPE, "; charset=UTF-8"))
};